'Lot'.datatype({exportable: true})
'product'.field({refersTo: 'products'})
'lotNumber'.field({key: true, nonUnique: true})
'expiryDate'.field({date: true, allowEmpty: true})

'Lot'.cruxFields(['product', 'lotNumber'])

'expiryDate'.default(global.emptyYMD())
